<template>
  <v-tooltip bottom color="white">
    <template v-slot:activator="{ on }">
      <v-chip id="storeOpenStatus"
        v-on="onFunction(on)"
        :small="small"
        label
        outline
        disabled
        :color="color"
        class="ma-0"
      >
        {{ text }}
      </v-chip>
    </template>

    <store-hours
      v-if="showAllHours"
      :store="store"
    />
  </v-tooltip>
</template>

<script>
  import { mapGetters } from 'vuex';
  
  import StoreHours from '@/components/StoreHours.vue';

  export default {
    props: {
      store: {
        type: Object,
        required: true,
        default: () => ({})
      },
      small: {
        type: Boolean,
        default: false
      },
      showAllHours: {
        type: Boolean,
        default: true
      }
    },

    components: {
      StoreHours
    },

    computed: {
      isOpen() {
        return this.testStore(this.store)
      },
      color() {
        return !this.isOpen ? 'red' : 'green'
      },
      text() {
        return !this.isOpen
          ? this.$vuetify.t('$vuetify.common.closed2')
          : this.$vuetify.t('$vuetify.common.open2')
      },

      ...mapGetters([ 'testStore' ])
    },
    methods: {
      onFunction(onFunction) {
        return this.showAllHours ? onFunction : {}
      }
    }
  }
</script>

<style>
  #storeOpenStatus.v-chip.v-chip.v-chip--outline {
    background-color: white !important;
    padding: 17px 10px;
  }

  #storeOpenStatus.v-chip .v-chip__content {
    font-size: 16px;
  }

  .v-tooltip__content {
    opacity: 1 !important;
    /* background: white !important; */
  }
</style>
